import Nav from '../components/Nav';

export default {
  init () {
    // JavaScript to be fired on all pages
    console.log('Common JS loaded')

    Nav();

    /**
     * Custom arrow buttons
     *
     * @PathwiseSolutions
     */

    const arrowBlue =
      '<svg class="ps-2" width="40" height="11" viewBox="0 0 64 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path style="fill: #5CE1E6;" fill-rule="evenodd" clip-rule="evenodd" d="M18.551 10.9782V0L36.1744 10.4293V0L64.0003 16.4669L36.1744 32.9339V22.5046L18.551 32.9339V21.9557L0 32.9339L1.29914e-06 0L18.551 10.9782Z" /></svg>'

    $('.n2-ss-button-container a').append(arrowBlue)

    $(
      '.btn, .wp-block-button__link, .tribe-events-widget-events-list__view-more-link'
    ).each(function () {
      $(this).append('<span></span>')
    })

    const fileIcon =
      '<svg width="12" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z"/></svg>'

    $('.wp-block-file').prepend(fileIcon)

    /**
     * Accordion Icons
     *
     */

    $('.wp-block-aab-accordion-item').each(function () {
      $(this)
        .find('.aagb__accordion_icon .aagb__icon')
        .removeClass('dashicons-plus-alt2')
        .addClass('dashicons-arrow-down')
    })

    /**
     * Custom arrow buttons
     *
     */

    $('.n2-ss-button-container a')
      .append(`<svg class="ps-2" width="40" height="11" viewBox="0 0 64 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path style="fill: #5CE1E6;" fill-rule="evenodd" clip-rule="evenodd" d="M18.551 10.9782V0L36.1744 10.4293V0L64.0003 16.4669L36.1744 32.9339V22.5046L18.551 32.9339V21.9557L0 32.9339L1.29914e-06 0L18.551 10.9782Z" />
    </svg>`)

    $('.more-link a.fwpl-btn')
      .append(`<svg class="ps-2" width="42" height="13" viewBox="0 0 64 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path style="fill: #CB6036;" fill-rule="evenodd" clip-rule="evenodd" d="M18.551 10.9782V0L36.1744 10.4293V0L64.0003 16.4669L36.1744 32.9339V22.5046L18.551 32.9339V21.9557L0 32.9339L1.29914e-06 0L18.551 10.9782Z" />
    </svg>`)

    $(
      '.btn, .wp-block-button__link, .tribe-events-widget-events-list__view-more-link'
    ).each(function () {
      $(this).append('<span></span>')
    })

    /**
     * Open external Links in new tab
     * Open PDFs in new tab
     *
     * @Pathwise
     */

    $('.section-content a:not(.external-exclude)')
      .filter(function () {
        return this.hostname && this.hostname !== location.hostname
      })
      .attr('target', '_blank')
      .addClass('external')

    $('a[href*="pdf"]').on('click', function (e) {
      e.preventDefault()
      const documentUrl = $(this).attr('href')
      window.open(documentUrl, '_blank')
    })
  },
  finalize () {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}
